import axios from 'axios';
import api from './api';

const callaxios = axios.create({
  // baseURL: 'http://3.228.238.128:7006/tasks',
  baseURL: `${api.baseUrl6}/tasks`,
  headers: {
    'content-type': 'application/json',
    // 'Access-Control-Allow-Origin': 'http://3.228.238.128:7006',
    // 'Access-Control-Allow-Origin': api.baseUrl6,
    // 'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, PUT, DELETE',
    // 'Access-Control-Allow-Headers': 'Content-Type, X-Auth-Token, Origin, Authorization, UserId'
  }
})

// configure headers
callaxios.interceptors.request.use(
  config => {
    if (sessionStorage.getItem('LOGGEDIN')) {
      config.headers['Authorization'] = 'Bearer ' + sessionStorage.getItem('JWT')
      config.headers['UserId'] = sessionStorage.getItem('USERID')
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default callaxios
